import { useEffect } from "react";
import { X } from "lucide-react";

export function BottomSheet({
  open,
  onClose,
  title,
  children,
  compact = false,
  layer = 50,
  contentClassName,
}: {
  open: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  compact?: boolean;
  layer?: number;
  contentClassName?: string;
}) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col justify-end"
      style={layer !== 50 ? { zIndex: layer } : undefined}
      data-bottom-sheet=""
    >
      <button
        type="button"
        aria-label="Close"
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative max-h-[85vh] overflow-hidden rounded-t-3xl border border-border bg-surface-elevated shadow-pulse">
        <div
          className={`flex items-center justify-between border-b border-border ${compact ? "px-4 py-3" : "px-5 py-4"}`}
        >
          <h2 className={compact ? "font-headline text-base font-bold" : "font-headline text-lg font-bold"}>{title}</h2>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="grid h-10 w-10 place-items-center rounded-full border border-border bg-surface"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <div
          className={
            contentClassName ??
            (compact ? "overflow-y-auto px-4 py-3 pb-24" : "overflow-y-auto px-5 py-4 pb-24")
          }
        >
          {children}
        </div>
      </div>
    </div>
  );
}
